// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductPreview_container__3BsU7"};